import React, { useState, useEffect, useRef } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { Link } from "react-router-dom";

const Hero = () => {
  const carouselData = [
    // { id: 1, title: "Prajakta La-Maison", tagline: "3&4 BHKD flats based on european theme", image: "/images/MP_01.png", status: "Ongoing", fonts: { title: "Dancing Script, cursive", status: "Julee, cursive", tagline: "Merriweather, serif" } },
    {
      id: 1,
      titleImage: "/La-maison-gallary/la-massion-name.png",
      title: "Prajakta La-Maison",
      tagline: "3&4 BHKD flats based on european theme",
      image: "/images/MP_01.png", status: "Ongoing",
      fonts: {
        title: "Parisienne, cursive",
        status: "Julee, cursive",
        tagline: "Merriweather, serif"
      }
    },
    {
      id: 2,
      titleImage: "/prajkata-park-name-leaf.png",
      title: "Prajakta Park",
      tagline: "3BHKD park facing premium flats in abhayankar nagar",
      image: "/ikebana/PRAJAKTA PARK BANNER.jpg",
      status: "Ongoing",
      fonts: {
        title: "Pinyon Script, cursive",
        status: "Dancing Script, cursive",
        tagline: "Calibri"
      }
    },
    { id: 3, title: "PRAJAKTA CLASSIC", tagline: "Classical theme based Spacious flats with garden and parking facility", image: "/images/park_img_page-0001.jpg", status: "Completed", fonts: { title: "Montserrat, sans-serif", status: "Julee, cursive", tagline: "Open Sans, sans-serif" } },
    { id: 4, title: "PRAJAKTA GREEN SERENITY", tagline: "Luxury with Quality and Tranquility", image: "/greenSerenity/1.jpeg", status: "Completed", fonts: { title: "Cinzel, serif", status: "Satisfy, cursive", tagline: "Merriweather, serif" } },
    { id: 5, title: "PRAJAKTA GREENFINITY", tagline: "Enjoy The Blissful Life in the Harmony of Mother Nature", image: "/images/post_01.png", status: "Completed", fonts: { title: "Cinzel, serif", status: "Satisfy, cursive", tagline: "Merriweather, serif" } },
    { id: 6, title: "PRAJAKTA IKEBANA", tagline: "Spacious Premium Apartments", image: "/images/Po.png", status: "Completed", fonts: { title: "Cinzel, serif", status: "Satisfy, cursive", tagline: "Merriweather, serif" } },
    { id: 7, title: "", tagline: "", status: "", image: "/images/certification.jpeg", fonts: { title: "", status: "", tagline: "" } },


  ];

  const carouseMobilelData = [
    { id: 1, titleImage: "/La-maison-gallary/la-massion-name.png", title: "Prajakta La-Maison", tagline: "3&4 BHKD flats based on european theme", image: "/images/p_la_maison_mobile.png", status: "Ongoing", fonts: { title: "Dancing Script, cursive", status: "Julee, cursive", tagline: "Merriweather, serif" } },
    {
      id: 2,
      titleImage: "/prajkata-park-name-leaf.png",
      title: "Prajakta Park",
      tagline: "3BHKD park facing premium flats in abhayankar nagar",
      // image: "/Prajkta-park-mobile.png",
      image: "/prajakta_part_mobile_new.png",
      status: "Ongoing",
      fonts: {
        title: "Pinyon Script, cursive",
        status: "Dancing Script, cursive",
        tagline: "Calibri"
      }
    },
    { id: 3, title: "PRAJAKTA CLASSIC", tagline: "Spacious flats with garden and parking facility", image: "/images/p_classic_mobile.jpg", status: "Completed", fonts: { title: "Montserrat, sans-serif", status: "Julee, cursive", tagline: "Open Sans, sans-serif" } },
    { id: 4, title: "PRAJAKTA GREEN SERENITY", tagline: "Luxury with Quality and Tranquility", image: "/greenSerenity/Green Serenity_360x800.png", status: "Completed", fonts: { title: "Cinzel, serif", status: "Satisfy, cursive", tagline: "Merriweather, serif" } },
    { id: 5, title: "PRAJAKTA GREENFINITY", tagline: "Enjoy The Blissful Life in the Harmony of Mother Nature", image: "/greenfinity/prajkta-greenfinity.png", status: "Completed", fonts: { title: "Cinzel, serif", status: "Satisfy, cursive", tagline: "Merriweather, serif" } },
    { id: 6, title: "PRAJAKTA IKEBANA", tagline: "Spacious Premium Apartments", image: "/prajaktaIkebana/prajakta_Ikebana_mobile.png", status: "Completed", fonts: { title: "Cinzel, serif", status: "Satisfy, cursive", tagline: "Merriweather, serif" } },
    { id: 7, title: "", tagline: "", status: "", image: "/Award-mobile.png", fonts: { title: "", status: "", tagline: "" } },
  ];

  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [isPaused, setIsPaused] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const activeData = isMobile ? carouseMobilelData : carouselData;
  const slides = [activeData[activeData.length - 1], ...activeData, activeData[0]];
  const [currentSlide, setCurrentSlide] = useState(1);
  const [transition, setTransition] = useState(true);
  const slideRef = useRef();
  const intervalRef = useRef(null);

  const nextSlide = () => setCurrentSlide((prev) => prev + 1);
  const prevSlide = () => setCurrentSlide((prev) => prev - 1);

  // 🔹 Auto Slide with Pause on Hover
  useEffect(() => {
    if (!isPaused) {
      intervalRef.current = setInterval(() => nextSlide(), 6000);
    }
    return () => clearInterval(intervalRef.current);
  }, [isPaused]);

  useEffect(() => {
    if (!transition) return;
    if (currentSlide === slides.length - 1) {
      setTimeout(() => {
        setTransition(false);
        setCurrentSlide(1);
      }, 1000);
    }
    if (currentSlide === 0) {
      setTimeout(() => {
        setTransition(false);
        setCurrentSlide(slides.length - 2);
      }, 1000);
    }
  }, [currentSlide, slides.length]);

  useEffect(() => {
    if (!transition) {
      setTimeout(() => setTransition(true), 50);
    }
  }, [transition]);

  return (
    <>
      {/* HERO SECTION */}
      <section
        className="relative h-screen w-full overflow-hidden"
        ref={slideRef}
        onMouseEnter={() => setIsPaused(true)}
        onMouseLeave={() => setIsPaused(false)}
        onTouchStart={() => setIsPaused(true)} // Pause on mobile touch
        onTouchEnd={() => setIsPaused(false)} // Resume when touch ends
      >
        <div
          className={`flex h-full w-full ${transition ? "transition-transform duration-1000 ease-in-out" : ""}`}
          style={{ transform: `translateX(-${currentSlide * 100}%)` }}
        >
          {slides.map((slide, index) => (
            <div key={index} className="min-w-full h-full relative">
              <img
                src={slide.image}
                alt={slide.title}
                className="w-full h-[100vh] sm:h-[100vh] lg:h-full object-fill"
              />

              {!isMobile && index === currentSlide && slide.title && (
                <>
                  <div className="absolute bottom-40 left-10 z-30 text-left max-w-[70%]">
                    <Link to={`/project/${slide.id}`}>
                      <button
                        className="mb-4 bg-gradient-to-r from-[#011321] to-[#03365f] text-white font-semibold uppercase tracking-wide px-6 py-3 rounded-full shadow-lg hover:scale-105 hover:shadow-2xl hover:from-[#02203d] hover:to-[#055a8b] transition-all duration-300"
                      >
                        Explore Project
                      </button>
                    </Link>
                  </div>

                  <div className="absolute bottom-10 left-10 z-30 text-left max-w-[70%]">
                    <div className="inline-block text-left">

                      {/* Only ID = 1 and ID = 2 → show titleImage */}
                      {(slide.id === 1 || slide.id === 2) ? (
                        <div className="relative px-1 py-4 rounded-lg bg-black/50 inline-block">

                          {/* Status Badge */}
                          <span
                            style={{ fontFamily: slide.fonts.status }}
                            className={`absolute -top-4 right-3 px-3 py-1 rounded-full text-sm md:text-base font-semibold shadow-lg ${slide.status === "Completed"
                              ? "bg-[#011321] text-white"
                              : "bg-yellow-400 text-black"
                              }`}
                          >
                            {slide.status}
                          </span>

                          {/* Title Image */}
                          <img
                            src={slide.titleImage}
                            alt="title"
                            className="h-[60px] md:h-[80px] lg:h-[70px] w-[260px] md:w-[340px] lg:w-[300px] object-contain drop-shadow-xl"
                          />

                          {/* Tagline */}
                          <span
                            style={{ fontFamily: slide.fonts.tagline }}
                            className="block text-sm md:text-lg lg:text-md font-normal tracking-normal text-white"
                          >
                            {slide.tagline}
                          </span>
                        </div>
                      ) : (
                        // Normal Title for other IDs
                        <h2
                          style={{ fontFamily: slide.fonts.title }}
                          className="relative px-1 py-4 rounded-lg text-2xl md:text-4xl lg:text-2xl font-extrabold tracking-wider drop-shadow-2xl bg-black/50 text-white"
                        >
                          <span
                            style={{ fontFamily: slide.fonts.status }}
                            className={`absolute -top-4 right-3 px-3 py-1 rounded-full text-sm md:text-base font-semibold shadow-lg ${slide.status === "Completed"
                              ? "bg-[#011321] text-white"
                              : "bg-yellow-400 text-black"
                              }`}
                          >
                            {slide.status}
                          </span>

                          {slide.title}

                          <span
                            style={{ fontFamily: slide.fonts.tagline }}
                            className="block text-sm md:text-lg lg:text-md font-normal tracking-normal"
                          >
                            {slide.tagline}
                          </span>
                        </h2>
                      )}

                    </div>
                  </div>


                </>
              )}
            </div>
          ))}
        </div>

        {/* Navigation Arrows */}
        <button
          onClick={prevSlide}
          className="absolute left-4 sm:left-6 top-1/2 -translate-y-1/2 z-40 
             p-3 sm:p-4 bg-slate-700/50 backdrop-blur-sm border border-slate-600/30 
             text-white rounded-full hover:bg-white/20 hover:border-white 
             transform hover:scale-110 transition-all duration-500"
        >
          <ChevronLeft className="w-6 h-6 sm:w-8 sm:h-8" />
        </button>

        <button
          onClick={nextSlide}
          className="absolute right-4 sm:right-6 top-1/2 -translate-y-1/2 z-40 
             p-3 sm:p-4 bg-slate-700/50 backdrop-blur-sm border border-slate-600/30 
             text-white rounded-full hover:bg-white/20 hover:border-white 
             transform hover:scale-110 transition-all duration-500"
        >
          <ChevronRight className="w-6 h-6 sm:w-8 sm:h-8" />
        </button>


      </section>

      {/* MOBILE BELOW OVERLAY */}
      {isMobile && slides[currentSlide] && slides[currentSlide].title && (
        <div className="absolute inset-0 flex flex-col justify-end items-start z-30" ref={slideRef}
          onMouseEnter={() => setIsPaused(true)}
          onMouseLeave={() => setIsPaused(false)}
          onTouchStart={() => setIsPaused(true)} // Pause on mobile touch
          onTouchEnd={() => setIsPaused(false)} >
          <div className="flex items-center justify-center gap-1 bg-black/50 px-2 py-2 rounded-xl">
            <img
              src="/images/WhatsApp Image 2025-09-13 at 16.54.10_b60a3e66.jpg"
              alt="Madhuprabha Construction Logo"
              className="w-16 h-16 md:w-27 md:h-27 lg:w-27 lg:h-27 object-full drop-shadow-lg rounded-full p-1 mt-6"
            />
            <div className="flex flex-col items-start ">
              <div className="flex items-center justify-center gap-2 -mt-2">
                {/* Explore Project Button */}
                {slides[currentSlide].id && (
                  <Link to={`/project/${slides[currentSlide].id}`}>
                    <button className="bg-gradient-to-r from-[#011321] to-[#03365f] text-white uppercase tracking-wide px-6 py-1 rounded-full shadow-lg hover:scale-105 hover:shadow-2xl hover:from-[#02203d] hover:to-[#055a8b] transition-all duration-300 text-sm whitespace-nowrap">
                      Explore Project
                    </button>
                  </Link>
                )}

                {/* Status Badge */}
                {slides[currentSlide]?.status && (
                  <span
                    style={{ fontFamily: slides[currentSlide]?.fonts?.status }}
                    className={`px-3 py-1 rounded-full text-xs sm:text-sm font-semibold shadow-md 
        ${slides[currentSlide].status === "Completed"
                        ? "bg-[#011321] text-white"
                        : "bg-yellow-400 text-black"
                      }`}
                  >
                    {slides[currentSlide].status}
                  </span>
                )}
              </div>
              {slides[currentSlide]?.id === 1 || slides[currentSlide]?.id === 2 ? (
                <img
                  src={slides[currentSlide]?.titleImage}
                  alt="Project Title"
                  className="h-[60px] md:h-[80px] lg:h-[70px] w-[220px] md:w-[340px] lg:w-[300px] object-contain drop-shadow-xl mx-auto"
                />
              ) : (
                <h2
                  style={{ fontFamily: slides[currentSlide]?.fonts?.title }}
                  className="text-1xl sm:text-1xl font-extrabold uppercase text-white drop-shadow-lg text-center"
                >
                  {slides[currentSlide]?.title}
                </h2>
              )}


            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Hero;
